/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaOnboarding/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaOnboarding({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaOnboarding",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaOnboarding.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-2apopj': alignSelf,'--mt-2-2apopj': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-2apopj': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2apopj': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2apopj': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-2apopj': opacity,'--w-10-2apopj': typeof width === 'number' ? `${width}px` : width,'--h-11-2apopj': typeof height === 'number' ? `${height}px` : height,'--f-12-2apopj': fill,'--a-7-2apopj': isAnimated ? animation : "none",'--sd-8-2apopj': isAnimated ? strokeDashoffset : 0,'--sd-9-2apopj': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaOnboarding.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M9.458 4.692l.662-1.707A1.539 1.539 0 0111.55 2h1.262a1.538 1.538 0 011.431.985l.662 1.707 2.246 1.293 1.815-.277a1.539 1.539 0 011.539.754l.615 1.076a1.538 1.538 0 01-.123 1.739l-1.123 1.43v2.585l1.154 1.431a1.538 1.538 0 01.123 1.739l-.616 1.076a1.54 1.54 0 01-1.538.754l-1.816-.277-2.246 1.293-.661 1.707a1.537 1.537 0 01-1.431.985h-1.292a1.538 1.538 0 01-1.431-.985l-.662-1.707-2.246-1.293-1.815.277a1.538 1.538 0 01-1.539-.754l-.615-1.076a1.539 1.539 0 01.123-1.739l1.123-1.43v-2.585L3.335 9.277a1.539 1.539 0 01-.123-1.739l.616-1.076a1.538 1.538 0 011.538-.754l1.815.277 2.277-1.293zm2.723 8.281a2.63 2.63 0 100-5.259 2.63 2.63 0 000 5.26zm3.584 2.383c.368.268.702.575.997.913a1.25 1.25 0 00-.58.177l-2.02 1.211a1.25 1.25 0 00-.51.591l-.654 1.57a.656.656 0 01-.155.212l-.012.003a.29.29 0 01-.044.003h-1.194a.276.276 0 01-.064-.037.605.605 0 01-.166-.187l-.652-1.564a1.25 1.25 0 00-.51-.591l-2.02-1.211a1.25 1.25 0 00-.58-.177 6.081 6.081 0 018.164-.913z"
 style={{'--f-12-2apopj': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}